import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Receipt } from "lucide-react";
import ElasticCardLookup from "./ElasticCardLookup";

let _statusCache = null;

export const ElasticHistoryButton = ({ cardNumber, size = "sm", className = "", testid = "crm-history-button" }) => {
  const [enabled, setEnabled] = useState(!!_statusCache?.configured);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (_statusCache) { setEnabled(!!(_statusCache.configured && _statusCache.enabled)); return; }
    api.get("/elastic/status").then(({ data }) => { _statusCache = data; setEnabled(!!(data.configured && data.enabled)); }).catch(() => {});
  }, []);

  if (!enabled || !cardNumber) return null;
  return (
    <>
      <Button type="button" variant="outline" size={size} onClick={() => setOpen(true)} data-testid={testid} className={`border-zinc-800 ${className}`}>
        <Receipt className="h-4 w-4 mr-1 text-amber-500" /> Storico CRM
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto bg-zinc-950 border-zinc-800" data-testid="crm-history-dialog">
          <DialogHeader><DialogTitle>Storico acquisti CRM · carta {cardNumber}</DialogTitle></DialogHeader>
          <ElasticCardLookup initialCard={cardNumber} autoSearch compact />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ElasticHistoryButton;
